app.controller('PaginationCtrl', function ($scope) {

    var self = this;

    // Build pagination after each search
    $scope.$on('resourceListPromiseSuccessful', function () {

        self.pageLinks = [];

        // if 10 or less pages we display all page links
        if ($scope.meta.pageCount <= 10) {
            for (var i = 1; i <= $scope.meta.pageCount; i++) {
                self.pageLinks.push(i);
            }
        } else {
            // Google-like smart pagination
            if ($scope.searchData.page <= 6) {
                var firstPage = 1;
                var lastPage = 10;
            } else if ($scope.searchData.page + 4 >= $scope.meta.pageCount) {
                var firstPage = $scope.meta.pageCount - 9;
                var lastPage = $scope.meta.pageCount;
            } else {
                var firstPage = $scope.searchData.page - 5;
                var lastPage = $scope.searchData.page + 4;
            }
            for (var i = firstPage; i <= lastPage; i++) {
                self.pageLinks.push(i);
            }
        }

    });

    // execute a search for a specific page
    self.goToPage = function (page) {
        if (page == $scope.searchData.page) {
            return false;
        }
        $scope.searchData.page = page;
        $scope.search($scope.searchData);
    };

});
